import { forwardRef, Ref } from 'react';

import { Stack } from '@mui/material';

import Typography from '../../../../../../../../components/Typography';
import { Bar } from './styles';
import { ProgressbarProps } from './types';

const Progressbar = (
  { label, value, color, className, ...props }: ProgressbarProps,
  ref: Ref<HTMLDivElement>
) => {
  return (
    <Stack
      {...props}
      ref={ref}
      direction="row"
      alignItems="stretch"
      overflow="hidden"
      borderRadius="8px 0 0 8px"
      className={className}
    >
      <Stack
        justifyContent="center"
        alignItems="center"
        p={1.25}
        bgcolor={color}
        position="relative"
        zIndex={1}
      >
        <Typography variant="h6" component="span" color="common.white">
          {label}
        </Typography>
      </Stack>
      <Bar color={color} value={value} />
    </Stack>
  );
};

export default forwardRef(Progressbar);
